require('./groupPanel')
require('./tabs')
require('./timeline')
require('./scrollToTop')
require('./slider')
require('./autoSlider')
require('./accodion')
require('./playButton')
require('./accent')
require('./comparison-table')
require('./hotspots')
require('./toggle')
require('./video');
require('./map');